export const ONE_SECOND = 1000;
export const TEN_SECONDS = ONE_SECOND * 10;

export const CARD_PAYMENT_TYPE = 'card';
